import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import { useAuthStore } from '../stores/auth-store';
import routes from './routes';

const createHistory = process.env.SERVER
  ? createMemoryHistory
  : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(
    process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
  ),
});

Router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresLogin && !authStore.isAuthenticated) {
    next({ name: "Login", query: to.query });
  }
  else if (to.name === "Login" && authStore.isAuthenticated) {
    next({ name: "Customers", query: {} });
  }
  else {
    next();
  }
})

export default Router;
